import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchInvitationStatus, resendInvitation, type InvitationStatus, type InvitationTarget } from '../api/invitationApi';
import { ADMIN_AUDIT_QUERY_KEY } from './useAdminAuditEvents';

export const invitationKey = ({ kind, id }: InvitationTarget) => ['invitation', kind, id] as const;

export const useInvitationStatus = (target: InvitationTarget) =>
  useQuery<InvitationStatus>({
    queryKey: invitationKey(target),
    queryFn: () => fetchInvitationStatus(target),
    // The job mints the token after the POST: a cached `resendable` must never re-enable the button.
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: true,
  });

export const useResendInvitation = (target: InvitationTarget) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => resendInvitation(target),
    retry: false,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: invitationKey(target) });
      qc.invalidateQueries({ queryKey: ADMIN_AUDIT_QUERY_KEY });
    },
  });
};
